import { gEnums } from "global/enums/globalEnums";
import { createRefPath_client, createRefPath_event } from "global/firestoreData/appData/appRefPaths";
import { useContext, useEffect, useState } from "react";
import { DatabaseContext } from "../DatabaseContext";
import { _showAppLogs } from "../LogContext";
import { ParentContext } from "../ParentContext";
import { useDataConditionals } from "./useDataConditionals";
import { PageAreaContext } from "../PageAreaContext";
import { convertHelpers } from "global/common/convert";
import { useAppData } from "./useAppData";

export const useItemData = ({ dataInit_state }) => {

  const { viewItem, uivi } = dataInit_state ?? {}

  const { getFilteredData } = useDataConditionals({ dataInit_state })

  // parentContexts
  const parentContexts = useContext(ParentContext)
  const { states, handlers } = parentContexts ?? {}
  const { homeInfo_state, clientInfo_state, eventInfo_state } = states ?? {}
  const { log_handlers } = handlers

  // pageAreaContext
  const pageAreaContext = useContext(PageAreaContext)
  const { pageArea_state } = pageAreaContext ?? {}
  const { pageData } = pageArea_state ?? {}

  // eventInfo_state
  const { appDataDocuments } = eventInfo_state ?? {}

  // databaseContext
  const databaseContext = useContext(DatabaseContext);
  const { database_fns } = databaseContext ?? {};

  // states
  const { pathViews, nonLandingView, view: currentPageView, viewKey: dataCollectionItemKey } = _.get(states, 'paps_state', {});
  const { events: eventKey, clients: clientKey } = pathViews ?? {}
  const _isClient = pathViews?.clients ? true : false
  const _isEvent = pathViews?.clients && pathViews?.events ? true : false

  const { dataSource } = viewItem ?? {}
  const { dataCollectionName, dataSourceType } = dataSource ?? {}

  const appDataDocument = appDataDocuments?.[dataCollectionName]

  const { updateDocuments } = useAppData()

  let trueUivi = uivi;

  const [itemDataInfo, setItemDataInfo] = useState()

  useEffect(() => {

    let cache_groupType = 'homeInfo';
    let cache_key = 'homeInfo';
    let storageKey;
    let _storageDocKey;
    let _isSingleDataItemm = dataCollectionItemKey && (nonLandingView === uivi)
    const _uivi = dataCollectionName || uivi
    let _isSingleDataItem = dataCollectionItemKey && (currentPageView === uivi) //&& (_uivi === uivi)

    if (_isEvent) {
      cache_groupType = 'eventInfo'
      cache_key = eventKey
      storageKey = `eventInfo-${eventKey}-appDataDocuments`
      _storageDocKey = `eventInfo-${eventKey}-documents-${dataCollectionName}`
    } else if (_isClient) {
      cache_groupType = 'clientInfo'
      cache_key = clientKey
      if (_isSingleDataItemm) {
        storageKey = `appInfo-clients`
      } else {
        storageKey = `clientInfo-${clientKey}-clientEvents`
      }
    } else {
      cache_groupType = 'homeInfo'
      cache_key = clientKey
      storageKey = `appInfo-clients`
    }

    const callback_data = (data) => {
      if (_showAppLogs.itemData) {
        console.group('callback_data', uivi)
        console.log('uivi', uivi)
        console.log('dataCollectionName', dataCollectionName)
        console.log('data', data)
        console.log('currentPageView', currentPageView)
        if (pageData?.[uivi]) {
          console.log('pageData', pageData?.[uivi]?.count, pageData?.[uivi]?.data)
        }
        console.log('itemData', _.size(data), data)
        console.groupEnd()
      }

      convertHelpers.createItemKeys(data)
      setItemDataInfo({ itemData: data, itemDataName: uivi, itemDataCollectionName: dataCollectionName })
    }

    // get the data from HOME
    const getData_home = async () => {
      if (homeInfo_state?.[trueUivi]) {
        callback_data(homeInfo_state?.[trueUivi])
      }
    }

    // gets the data for CLIENT
    const getData_client = async () => {
      if (clientInfo_state?.[trueUivi]) {
        callback_data(clientInfo_state?.[trueUivi])
        return;
      }

      const cb_client = async (fetchedData) => {
        _showAppLogs.dbFetch && log_handlers.addLog(`🌐💾 Fetched item data(${dataCollectionName}) from Firebase`);
        const dataState = {
          viewItem: dataCollectionName,
          uivi: dataCollectionName
        }
        getFilteredData(fetchedData, callback_data, dataState)
      };

      getData_collection(database_fns, _isEvent, _isClient, dataCollectionName, pathViews, trueUivi, callback_data, cb_client)
    }

    // gets the data for EVENT
    const getData_event = async () => {

      if (!appDataDocuments) {
        _showAppLogs.dbFetch && log_handlers.addLog(`⚠️ No appDataDocuments. Looking for ${dataCollectionName}`);
        _showAppLogs.dbFetch && log_handlers.addLog(`⚠️ ${appDataDocuments}`);
      }

      const fromCache = 'cache'

      if (appDataDocument) {
        convertHelpers.createItemKeys(appDataDocument)
        if (_isSingleDataItem) {
          const _itemData = {
            [dataCollectionItemKey]: appDataDocument?.[dataCollectionItemKey]
          }
          _showAppLogs.itemData && log_handlers.addLog(`♻️💾 Loaded item data (${dataCollectionName}-${dataCollectionItemKey}) from ${fromCache}`);
          callback_data(_itemData)
          return;
        }
        _showAppLogs.itemData && log_handlers.addLog(`♻️💾 Loaded collection data (${dataCollectionName})(${_.size(appDataDocument)}) from ${fromCache}`);
        getFilteredData(appDataDocument, callback_data)
        return;
      }

      // 2️⃣ Listen for Firestore updates
      const cb_event = async (fetchedData) => {
        _showAppLogs.dbFetch && log_handlers.addLog(`🌐💾 Fetched item data(${dataCollectionName}) from Firebase`);
        if (!dataCollectionItemKey) {
          const cbx = (updatedData) => { console.log('Updated') }
          updateDocuments(_uivi, fetchedData, cbx)
        }
        getFilteredData(fetchedData, callback_data)
      };

      getData_collection(database_fns, _isEvent, _isClient, dataCollectionName, pathViews, trueUivi, callback_data, cb_event)

    }

    const getData = async () => {
      // const {   fromDocCache } = await getCachedData()

      if (_isEvent) {
        getData_event()
      } else if (_isClient) {
        getData_client()
      } else {
        getData_home()
      }
    }

    switch (dataSourceType) {
      case gEnums.dataSourceTypes.component:
        callback_data({})
        break;
      case gEnums.dataSourceTypes.googleSheet:
        callback_data({})
        break;
      case gEnums.dataSourceTypes.none:
        callback_data({})
        break;
      default:
        getData()
    }

  }, [trueUivi, pathViews, appDataDocument, pageData]);

  return { itemDataInfo };
};

const getData_collection = (database_fns, _isEvent, _isClient, dataCollectionName, pathViews, trueUivi, cbData, cb) => {
  try {
    let refPath;
    if (_isEvent && trueUivi) {
      // get the data from the event root
      refPath = createRefPath_event(pathViews, [trueUivi])
    } else if (_isClient && trueUivi) {
      // get the data from the client root
      refPath = createRefPath_client(pathViews, [trueUivi])
    } else {
      // get the data from the root
      cbData({})
    }
    if (refPath) {
      database_fns.get_data({
        refPath,
        callback: cb,
        opts: { listen: true },
      });
    }
  } catch (err) {
    _showAppLogs.dbFetch && log_handlers.addLog(`❌💾 Failed to fetch data${dataCollectionName}`, err);
  }
}